import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { GQL_QUERY_ALL_BANNERS } from '@entities/Banners/model/queries'

import { IMAGE_SIZES, ImageSize } from '@shared/contants'
import { AllBannersQuery, AllBannersQueryVariables } from '@shared/generated'


type useAllBannersParams = {
  bannerType?: string | null;
  typeId?: string | null;
  limit?: number;
  page?: number;
  style?: ImageSize;
  mobileSlideStyle?: ImageSize;
  fetchPolicy?: 'cache-and-network' | 'network-only' | 'cache-first' | 'no-cache';
}

export function useAllBanners ({
  bannerType = null,
  typeId = null,
  limit = 12,
  page = 1,
  style = IMAGE_SIZES.FULLHD,
  mobileSlideStyle = IMAGE_SIZES.HERO,
  fetchPolicy = 'cache-and-network',
}: useAllBannersParams = {
}) {
  const { data, loading, error } = useQuery<AllBannersQuery, AllBannersQueryVariables>(
    GQL_QUERY_ALL_BANNERS,
    {
      variables: {
        pager: { limit, page },
        style,
        bannerMobileSlideStyle2: mobileSlideStyle,
        filter: {
          or: [
            {
              fields: [ 'code' ],
              op: 'eq',
              value: [ bannerType ]
            },
            {
              fields: [ 'typeId' ],
              op: 'eq',
              value: [ typeId ]
            }
          ]
        },
      },
      fetchPolicy
    }
  )

  const banners = useMemo(() => data?.allBanners?.edges?.filter(Boolean) || [], [ data ])

  return { 
    data, 
    banners,
    loading, 
    error
  }
}